// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"fc64aaef","667":"a32ccf46"}[chunkId] + ".chunk.js";
};